import "./styles.less";
import { useContext } from "react";
import { ConfigStateContext } from "shared-components/Contexts/Configurations/context";
import { ListingData, genTagsText } from "shared-components/ViewFragments/SearchPage/ListingCard";
import { useTheme } from "shared-components/Styles/ThemeHook";

export function ListingTypeTag({ id, data, signalsV2 = false, hideTier = false }: { id: string, data?: ListingData, signalsV2?: boolean, hideTier?: boolean }) {
	if (!data) return null;

	const { theme } = useTheme();
	const { country_code } = useContext(ConfigStateContext)
	const tags = genTagsText(data, country_code, theme.colors.primaryColor, { signalsV2, hideTier })

	return (
		<div className={`tags-container${signalsV2 ? " signals-v2" : ""}`}>
			{tags?.map((t, i) => (
				<span className={`lc-tags tag-${t.name} ${t.text ? "text-tag" : "icon-tag"}`} key={i}>
					{t.icon && t.icon}
					{t.text}
				</span>
			))}
		</div>
	);
}
